import type { BrickType } from "./types";

// Standard LEGO brick library - most common bricks first for optimization
export const LEGO_BRICK_TYPES: BrickType[] = [
  // Most common and versatile bricks
  {
    id: "1x1",
    name: "1x1 Brick",
    width: 1,
    height: 1,
    description: "Basic 1x1 brick",
    isCommon: true,
  },
  {
    id: "1x2",
    name: "1x2 Brick",
    width: 1,
    height: 2,
    description: "Common 1x2 brick",
    isCommon: true,
  },
  {
    id: "2x2",
    name: "2x2 Brick",
    width: 2,
    height: 2,
    description: "Versatile 2x2 brick",
    isCommon: true,
  },
  {
    id: "2x4",
    name: "2x4 Brick",
    width: 2,
    height: 4,
    description: "Standard 2x4 brick",
    isCommon: true,
  },

  // Common specialized bricks
  {
    id: "1x3",
    name: "1x3 Brick",
    width: 1,
    height: 3,
    description: "1x3 brick",
    isCommon: true,
  },
  {
    id: "1x4",
    name: "1x4 Brick",
    width: 1,
    height: 4,
    description: "1x4 brick",
    isCommon: true,
  },
  {
    id: "2x3",
    name: "2x3 Brick",
    width: 2,
    height: 3,
    description: "2x3 brick",
    isCommon: true,
  },
  {
    id: "2x6",
    name: "2x6 Brick",
    width: 2,
    height: 6,
    description: "2x6 brick",
    isCommon: false,
  },

  // Larger bricks for efficiency
  {
    id: "2x8",
    name: "2x8 Brick",
    width: 2,
    height: 8,
    description: "Large 2x8 brick",
    isCommon: false,
  },
  {
    id: "4x4",
    name: "4x4 Brick",
    width: 4,
    height: 4,
    description: "Large 4x4 brick",
    isCommon: false,
  },
  {
    id: "4x6",
    name: "4x6 Brick",
    width: 4,
    height: 6,
    description: "Large 4x6 brick",
    isCommon: false,
  },
  {
    id: "4x8",
    name: "4x8 Brick",
    width: 4,
    height: 8,
    description: "Large 4x8 brick",
    isCommon: false,
  },

  // Plates (thinner bricks)
  {
    id: "1x1p",
    name: "1x1 Plate",
    width: 1,
    height: 1,
    description: "1x1 plate",
    isCommon: true,
  },
  {
    id: "1x2p",
    name: "1x2 Plate",
    width: 1,
    height: 2,
    description: "1x2 plate",
    isCommon: true,
  },
  {
    id: "2x2p",
    name: "2x2 Plate",
    width: 2,
    height: 2,
    description: "2x2 plate",
    isCommon: true,
  },
  {
    id: "2x4p",
    name: "2x4 Plate",
    width: 2,
    height: 4,
    description: "2x4 plate",
    isCommon: true,
  },
];
